import React from "react";
import "./workcommand.css";
import img from "../../../images/logo.jpg";
const Commandwork = ({
  appdata,
  userData,
  mandopNationid,
  mandopPhone,
  mandopName,
  details,
}) => {
  // const days = [
  //   "اﻷحد",
  //   "اﻷثنين",
  //   "الثلاثاء",
  //   "اﻷربعاء",
  //   "الخميس",
  //   "الجمعة",
  //   "السبت",
  // ];

  const d = new Date();
  // let day = days[d.getDay()]; //
  return (
    <div id="commandwork">
      <img src={img} alt="" />
      <h3 className="text-center">امر شغل خدمة</h3>

      <h5 className="text-center">بيانات العميل</h5>
      <div className="content-cpmmand">
        <div>
          <h5>اسم العميل : {appdata.client.client_username}</h5>
          <h5>العنوان : {appdata.client.client_address}</h5>
        </div>
        <div>
          <h5>الرقم القومي : {appdata.client.client_national_id}</h5>
          <h5>رقم الهاتف : {appdata.client.client_mobile}</h5>
        </div>
      </div>

      <h5 className="text-center">بيانات الخدمة</h5>
      <div className="content-cpmmand">
        <div>
          <h5>
            نوع الخدمة :{" "}
            {appdata.application.application_type === 1
              ? "سيارات"
              : appdata.application.application_type === 2
              ? "حجز تذكرة طيران "
              : appdata.application.application_type === 3
              ? "فيزا "
              : appdata.application.application_type === 4
              ? "اقامة"
              : appdata.application.application_type === 5
              ? "خدمات المرور"
              : appdata.application.application_type === 6
              ? "خدمات الشهر العقاري"
              : appdata.application.application_type === 7
              ? "خدمات المحليات "
              : ""}
          </h5>
          <h5>
            تاريخ الطلب :{" "}
            {new Date(appdata.application.creation_date).toLocaleDateString(
              "ar-eg"
            )}
          </h5>
        </div>
        <div>
          <h5>
            وصف الخدمة :{" "}
            {appdata.car_details
              ? "طلب سيارة"
              : appdata.tickets
              ? "حجز تذكرة طيران"
              : appdata.tourist_application&&appdata.tourist_application.type === "visa"
              ? "فيزا "
              : appdata.tourist_application&&appdata.tourist_application.type === "residence"
              ? "اقامة"
              : appdata.traffic_services&&appdata.traffic_services.type === "new" &&
                appdata.traffic_services&&appdata.traffic_services.category === 1
              ? "استخراج رخصة جديدة (افراد)"
              : appdata.traffic_services&&appdata.traffic_services.type === "renewal" &&
                appdata.traffic_services&&appdata.traffic_services.category === 1
              ? "تجديد رخصة (افراد)"
              : appdata.traffic_services&&appdata.traffic_services.type === "instead" &&
                appdata.traffic_services&&appdata.traffic_services.category === 1
              ? "بدل فاقد (افراد)"
              : appdata.traffic_services&&appdata.traffic_services.type === "new" &&
                appdata.traffic_services&&appdata.traffic_services.category === 2
              ? "استخراج رخصة جديدة (سيارات)"
              : appdata.traffic_services&&appdata.traffic_services.type === "renewal" &&
                appdata.traffic_services&&appdata.traffic_services.category === 2
              ? "تجديد رخصة (سيارات)"
              : appdata.traffic_services&&appdata.traffic_services.type === "instead" &&
                appdata.traffic_services&&appdata.traffic_services.category === 2
              ? "بدل فاقد (سيارات)"
              : appdata.realestate&&appdata.realestate.category === 1
              ? " - أعمال التوكيلات"
              : appdata.realestate&&appdata.realestate.category === 2
              ? " - طلب الأستخراج"
              : appdata.realestate&&appdata.realestate.category === 3
              ? " - أعمال التحرير والتوثيق"
              : appdata.realestate&&appdata.realestate.type === 1
              ? "تحرير توكيل عام قضايا"
              : appdata.realestate&&appdata.realestate.type === 2
              ? "تحرير اقرار بالشطب"
              : appdata.realestate&&appdata.realestate.type === 3
              ? "تحرير بعدم وجود تعديل على البيانات المساحية"
              : appdata.realestate&&appdata.realestate.type === 4
              ? "تحرير اقرار رسمي"
              : appdata.realestate&&appdata.realestate.type === 5
              ? "تحرير توكيل رسمي"
              : appdata.realestate&&appdata.realestate.type === 6
              ? "تحرير توكيل رسمي شامل بنوك"
              : appdata.realestate&&appdata.realestate.type === 7
              ? "تحرير توكيل قضايا"
              : appdata.realestate&&appdata.realestate.type === 8
              ? "تحرير توكيل في الامور الزوجية"
              : appdata.realestate&&appdata.realestate.type === 9
              ? "توكيل في الامور الزوجية"
              : appdata.realestate&&appdata.realestate.type === 10
              ? "توكيل رسمي عام"
              : appdata.realestate&&appdata.realestate.type === 11
              ? "توكيل عام قضايا"
              : appdata.realestate&&appdata.realestate.type === 12
              ? "توكيل خاص"
              : appdata.realestate&&appdata.realestate.type === 13
              ? "توكيل شامل"
              : appdata.realestate&&appdata.realestate.type === 14
              ? "صورة من عقد مشهر"
              : appdata.realestate&&appdata.realestate.type === 15
              ? "صورة من كتاب دوري"
              : appdata.realestate&&appdata.realestate.type === 16
              ? "صورة من منشور فني"
              : appdata.realestate&&appdata.realestate.type === 17
              ? "صورة من منشور مالي"
              : appdata.realestate&&appdata.realestate.type === 18
              ? "شهادة تصرفات عقاري"
              : appdata.realestate&&appdata.realestate.type === 18
              ? "شهادة تصرفات عقاري"
              : appdata.local_services&&appdata.local_services.type === 1
              ? "خدمات البناء"
              : appdata.local_services&&appdata.local_services.type === 2
              ? "خدمات الأراضي"
              : appdata.local_services&&appdata.local_services.type === 3
              ? "خدمات الأشغالات"
              : appdata.local_services&&appdata.local_services.type === 4
              ? "خدمات الأعلانات"
              : appdata.local_services&&appdata.local_services.type === 5
              ? "خدمات المصاعد"
              : appdata.local_services&&appdata.local_services.type === 6
              ? "خدمات المحلات التجارية"
              : appdata.local_services&&appdata.local_services.type === 7
              ? "خدمات اخرى"
              : null}
          </h5>
          <h5>ملاحظات العميل : {details}</h5>
        </div>
      </div>
      <h5 className="text-center">بيانات المندوب</h5>

      <div className="content-cpmmand">
        <div>
          <h5>
            استلمت انا / {mandopName} بطاقة رقم /{mandopNationid} رقم هاتف /
            {mandopPhone} طلب العميل / {appdata.client.client_username}{" "}
          </h5>
        </div>
        <div>
          <br />
          <br />
          <h5>التوقيع / ......................</h5>
          <h5>تاريخ يوم الطباعة {d.toLocaleDateString("ar-eg")}</h5>
        </div>
      </div>
      <h5 className="text-center">ملحوظات الطلب (تملئ بمعرفة مستشار الطلب)</h5>

      <div className="content-dottt">
        ....................................................................................................................................................................................................................................................................................................................................
        <br />
        ....................................................................................................................................................................................................................................................................................................................................
        <br />
        ....................................................................................................................................................................................................................................................................................................................................
        <br />
        ....................................................................................................................................................................................................................................................................................................................................
        <br />
        ....................................................................................................................................................................................................................................................................................................................................
        <br />
      </div>
    </div>
  );
};

export default Commandwork;
